import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { BehaviorSubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-pagination-server-side-v2',
  templateUrl: './pagination-server-side-v2.component.html',
  styleUrls: ['./pagination-server-side-v2.component.css'],
})

export class PaginationServerSideV2Component implements OnInit, OnDestroy {

  @Input() agGridReference: AgGridAngular;
  @Output() onMorePageClick = new EventEmitter<any>();
  
  private subs = new SubSink();

  rowPerPage = 10;
  currentPage: number;
  totalPage: BehaviorSubject<number>;
  getRowClass = params => {
    if (params.node.rowIndex % 2 === 1) {
      return 'ag-grid-odd-rows';
    }
    return '';
  }

  showMorePage: boolean = false;

  constructor() {
    this.currentPage = 1;
    this.totalPage = new BehaviorSubject<number>(1);
  }

  ngOnInit() {
    this.subs.sink = this.agGridReference.gridReady.pipe(
      map( () => this.agGridReference.api.paginationGetTotalPages()),
      map( b => b ? this.totalPage.next(b) : this.totalPage.next(1)),
      switchMap(() => this.agGridReference.paginationChanged.asObservable()),
      map( () => this.agGridReference.api.paginationGetTotalPages()),
    ).subscribe( resolve => {
      resolve ? this.totalPage.next(resolve) : this.totalPage.next(1);
    });
  }

  onRowChange(row: number) {
    this.rowPerPage = row;
    this.agGridReference.api.paginationSetPageSize(row);
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
    if (row > 5) {
      this.agGridReference.api.setDomLayout('normal');
    } else {
      this.agGridReference.api.setDomLayout('autoHeight');
    }
  }

  firstPage() {
    this.agGridReference.api.paginationGoToFirstPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  }

  previousPage() {
    this.agGridReference.api.paginationGoToPreviousPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  }

  nextPage() {
    this.agGridReference.api.paginationGoToNextPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  }

  lastPage() {
    this.agGridReference.api.paginationGoToLastPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  }

  morePage() {
    this.onMorePageClick.emit();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
